import React from "react";
import { connect } from "react-redux";
import { TableRow, TableCell, IconButton, Modal } from "@mui/material";
import { BluetoothDisabled, PermDeviceInformation } from "@mui/icons-material";
import moment from "moment";
import Datatable from "../../../../partials/datatable/Datatable";
import { DevicesApiService } from "../../../../services/Ananse/DevicesApiService";
import ConfirmChangeStatusDialog from "../../../../partials/datatable/ConfirmChangeStatusDialog";
import translate from "@noar-firmenich/commons";
import { getTokenByDevice } from "@noar-firmenich/commons/lib/hash";
import Swal from "sweetalert2";
import Loading from "../../../home/components/Loading";
import styled from "styled-components";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import store from "app/store/store";

class DevicesListing extends React.Component {
  constructor(props) {
    super(props);

    this.api = new DevicesApiService();
    this.setDevices = this.setDevices.bind(this);
    this.disconnectDevice = this.disconnectDevice.bind(this);
    this.showTokenModal = this.showTokenModal.bind(this);
  }

  state = {
    devices: [],
    reload: false,
    toggleConfirmDialog: false,
    showResetModal: false,
    resetFirmewareCode: null,
    remainingSecondsCode: null,
    selectedDevice: null,
    showLoading: false
  };

  setDevices(devices) {
    this.setState({ devices });
  }

  async disconnectDevice() {
    const { selectedDevice } = this.state;
    const { i18n } = this.props;
    const locale = i18n.lang;
    try {
      this.setState({ toggleConfirmDialog: false, showLoading: true });
      await this.api.removeUser(selectedDevice);

      this.setState({ showLoading: false });
      Swal.fire({
        title: translate(locale).defaultMessages?.success,
        text: translate(locale).screens.device?.messages?.success,
        icon: "success",
        cancelButtonText: translate(locale).buttons?.exit,
        onAfterClose: () => this.setState({ reload: true })
      });
    } catch (e) {
      console.log(e);
      this.setState({ showLoading: false });
      Swal.fire(
        translate(locale).defaultMessages?.error,
        translate(locale).screens.device?.errors?.disconnect,
        "error"
      );
    }
  }

  async showTokenModal(device) {
    const result = getTokenByDevice(device.macAddress);
    //console.log(`get token from device: ${device.macAddress}`, result);
    const sleep = m => new Promise(r => setTimeout(r, m));
    this.setState({ showResetModal: true, resetFirmewareCode: result.token });

    for (let i = result.remainingSeconds; i > 0; i--) {
      if (
        this.state.showResetModal === false &&
        i !== result.remainingSeconds
      ) {
        break;
      }
      this.setState({ remainingSecondsCode: i });
      await sleep(1000);
    }

    if (this.state.showResetModal === true) {
      this.setState({
        resetFirmewareCode: "GETTING NEW",
        remainingSecondsCode: null
      });
      this.showTokenModal(device);
    }
  }

  render() {
    window.setPageTitle(
      `${this.props.translate.screens.device?.title || "Device"} - Admin`
    );

    const ModalContainer = styled.div`
      display: flex;
      align-items: center;
      justify-content: center;

      width: fit-content;
      height: 100%;
      margin: auto;
      outline: none;
    `;

    const DivResetFirmeware = styled.div`
      border-radius: 3px;
    `;

    const headRows = [
      { label: this.props.translate.screens.quiz.list.actions },
      {
        column: "MacAddress",
        label: this.props.translate.screens.device?.labels?.macAddress
      },
      {
        column: "Campaign.Name",
        label: this.props.translate.screens.quiz.list.campaign
      },
      {
        column: "User.Nome",
        label: this.props.translate.screens.device?.labels?.user
      },
      {
        column: "UpdatedAt",
        label: this.props.translate.screens.quiz.list.updated
      },
      {
        column: "Owner.Nome",
        label: this.props.translate.screens.device?.labels?.owner
      },
      {
        column: "CreatedAt",
        label: this.props.translate.screens.quiz.list.created
      }
    ];
    const { auth } = store.getState();
    const isDiffAdmin =
      auth && auth.user && auth.user.profile.nome.toUpperCase() === "ADMIN";

    const formatRow = r => (
      <TableRow hover tabIndex={-1} key={r.deviceId}>
        <TableCell>
          <div
            className={{
              display: "flex",
              flexDirection: "row"
            }}
            key={"actions-" + r.deviceId}
          >
            {isDiffAdmin && (
              <IconButton
                size="small"
                style={{
                  margin: 0,
                  color: "#0D2551"
                }}
                title={this.props.translate.screens.device?.labels?.modal}
                onClick={() => this.showTokenModal(r)}
              >
                <PermDeviceInformation fontSize="small" />
              </IconButton>
            )}

            {r.user && r.user.nome && (
              <IconButton
                size="small"
                style={{
                  margin: 0,
                  color: "#0D2551"
                }}
                title={this.props.translate.screens.device?.labels?.disconnect}
                onClick={() =>
                  this.setState({
                    toggleConfirmDialog: true,
                    selectedDevice: r.deviceId
                  })
                }
              >
                <BluetoothDisabled fontSize="small" />
              </IconButton>
            )}
          </div>
        </TableCell>
        <TableCell scope="row">{r.macAddress}</TableCell>
        <TableCell scope="row">{r.campaign?.name}</TableCell>
        <TableCell scope="row">{r.user?.nome}</TableCell>
        <TableCell scope="row">
          {moment(r.updatedAt).format("DD/MM/YYYY HH:mm")}
        </TableCell>
        <TableCell scope="row">{r.owner?.nome}</TableCell>
        <TableCell scope="row">
          {moment(r.createdAt).format("DD/MM/YYYY HH:mm")}
        </TableCell>
      </TableRow>
    );

    return (
      <>
        <Loading isLoading={this.state.showLoading} />
        <ConfirmChangeStatusDialog
          open={this.state.toggleConfirmDialog}
          closeDialog={() =>
            this.setState({ toggleConfirmDialog: false, selectedDevice: null })
          }
          confirm={this.disconnectDevice}
          message={this.props.translate.screens.device?.messages?.disconnect}
          title={translate(this.props.i18n.lang).changeStatus.confirmTitle}
        />
        {this.state.showResetModal && (
          <Modal
            open={this.state.showResetModal}
            onClose={() =>
              this.setState({
                showResetModal: false,
                selectedDevice: null,
                resetFirmewareCode: null
              })
            }
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <ModalContainer>
              <>
                <div className="container-modal">
                  <span className="title p-1 m-3 text-justify">
                    {this.props.translate.screens.device?.messages?.modal}
                  </span>
                  <CountdownCircleTimer
                    isPlaying={true}
                    duration={60}
                    initialRemainingTime={this.state.remainingSecondsCode}
                    colors={[
                      ["#004777", 0.4],
                      ["#F7B801", 0.4],
                      ["#A30000", 0.2]
                    ]}
                  >
                    {({ remainingTime }) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <div style={{ fontSize: "3rem" }}>{remainingTime}s</div>
                        <DivResetFirmeware className="title shadow bg-white p-2 ">
                          {this.state.resetFirmewareCode}
                        </DivResetFirmeware>
                      </div>
                    )}
                  </CountdownCircleTimer>
                  {/* {this.state.remainingSecondsCode && <RemainingSeconds>
                    {this.state.remainingSecondsCode}s
                  </RemainingSeconds>} */}
                  <div className="d-flex justify-content-between pt-5">
                    <button
                      onClick={() =>
                        this.setState({
                          showResetModal: false,
                          selectedDevice: null
                        })
                      }
                      type="button"
                      className="btn btn-secondary"
                    >
                      {translate(this.props.i18n.lang).buttons?.close}
                    </button>
                  </div>
                </div>
              </>
            </ModalContainer>
          </Modal>
        )}

        <Datatable
          title={this.props.translate.screens.device?.title}
          endpoint="/devices"
          headRows={headRows}
          formatRow={formatRow}
          rows={this.state.devices}
          setRows={this.setDevices}
          reload={this.state.reload}
          disableStatus={true}
          placeholderSearch={
            this.props.translate.screens.device?.placeholders?.filter
          }
        />
      </>
    );
  }
}

const mapStoreToProps = store => ({
  i18n: store.i18n
});

export default connect(mapStoreToProps, null)(DevicesListing);
